class BookingLivePricing {

    constructor(el) {
        this.el = el;
        // get other elements in the page
        this.desktopContinueBtn = document.querySelector('.desktop-continue-panel .btn.btn-primary');
        this.orderSummaryPanel = {
            itemCountContainer: document.querySelector('#order-summary--items-in-basket'),
            totalContainer: document.querySelector('#order-summary--total'),
            continueBtn: document.querySelector('#order-summary .btn.btn-primary'),
        }
        this.checkboxes = [];
        let findCheckboxes = el.querySelectorAll('input[data-price]');
        if(findCheckboxes != null) {
            findCheckboxes.forEach(c => {
                this.checkboxes.push({
                    el: c,
                    price: parseFloat(c.dataset.price)
                });
                c.addEventListener('change', () => {
                    this.update();
                });
            });
        }
        // also run update on radio-collapse-control 'rccChange' event
        window.addEventListener('rccChange', () => {
            this.update();
        });
    }

    update() {
        let items = 0,
            total = 0,
            enableContinueBtns = false;
        this.checkboxes.forEach(c => {
            if(c.el.checked) {
                items++;
                total += c.price;
            }
        });
        let writeTotal = 0;
        if (items > 0) {
            enableContinueBtns = true;
            if(total > Math.floor(total)) {
                writeTotal = `£${total.toFixed(2)}`;
            } else {
                writeTotal = `£${total.toFixed(2) }`;
            }
        }
        this.orderSummaryPanel.itemCountContainer.innerHTML = items;
        this.orderSummaryPanel.totalContainer.innerHTML = writeTotal;
        if(enableContinueBtns) {
            if(this.desktopContinueBtn) this.desktopContinueBtn.removeAttribute('disabled');
            if(this.orderSummaryPanel.continueBtn) this.orderSummaryPanel.continueBtn.removeAttribute('disabled');
        } else {
            if(this.desktopContinueBtn) this.desktopContinueBtn.setAttribute('disabled', 'disabled');
            if(this.orderSummaryPanel.continueBtn) this.orderSummaryPanel.continueBtn.setAttribute('disabled', 'disabled');
        }
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new BookingLivePricing(node);
        }
    });
}